'use client';
import {
  ArrowDown10,
  ArrowDownAZ,
  ArrowDownZa,
  CalendarArrowDown,
  FilterIcon,
  Heart,
  MapPinHouse,
} from 'lucide-react';
import dynamic from 'next/dynamic';
import { Button } from '../../components/button';
import { ResponsiveSelect } from '../../components/responsive-select';

import {
  attendantSearchSortByCreatedAt,
  attendantSearchSortByDistance,
  attendantSearchSortByNameAsc,
  attendantSearchSortByNameDesc,
  attendantSearchSortByReviews,
  attendantsFilterTitle,
  filterResultsAmount,
} from '@bells/i18n';
import { AttendantSearchSortBy } from '@bells/schema/models/attendant';
import { useFilter } from './filter-provider';
const AttendantSidebarFilter = dynamic(
  () => import('./attendant-sidebar-filter'),
  {
    ssr: false,
  }
);

const AttendantToolbar = () => {
  const { data, setShowFilter, filters, setFilters, totalFilters } =
    useFilter();
  return (
    <>
      <AttendantSidebarFilter></AttendantSidebarFilter>
      <div className='sticky top-[58px] z-10 flex items-center justify-between border-b p-4 py-2 backdrop-blur duration-0 supports-[backdrop-filter]:bg-background/60 lg:relative lg:top-[0] lg:px-8 xl:pl-8 xl:pr-0'>
        <span className='hidden whitespace-nowrap text-sm text-muted-foreground lg:inline-block'>
          {filterResultsAmount({ amount: data?.body.meta.totalItems ?? 0 })}
        </span>
        <div className='flex flex-1 items-center justify-between gap-2 lg:justify-end'>
          <ResponsiveSelect
            title={'Sort'}
            isOptional={false}
            ordered={false}
            value={
              filters.sortBy
                ? filters.sortBy.toString()
                : AttendantSearchSortBy.DISTANCE_ASC.toString()
            }
            onChange={(val) =>
              val
                ? setFilters((prev) => ({
                    ...prev,
                    page: 1,
                    sortBy: val as AttendantSearchSortBy,
                  }))
                : undefined
            }
            size={'sm'}
            className='lg:max-w-auto w-full max-w-[150px] lg:min-w-[250px]'
            options={[
              {
                value: AttendantSearchSortBy.DISTANCE_ASC,
                label: attendantSearchSortByDistance(),
                icon: <MapPinHouse></MapPinHouse>,
              },
              {
                value: AttendantSearchSortBy.NAME_ASC,
                label: attendantSearchSortByNameAsc(),
                icon: <ArrowDownAZ></ArrowDownAZ>,
              },
              {
                value: AttendantSearchSortBy.NAME_DESC,
                label: attendantSearchSortByNameDesc(),
                icon: <ArrowDownZa></ArrowDownZa>,
              },
              {
                value: AttendantSearchSortBy.CREATED_AT_ASC,
                label: attendantSearchSortByCreatedAt(),
                icon: <CalendarArrowDown></CalendarArrowDown>,
              },
              {
                value: AttendantSearchSortBy.RATINGS_DESC,
                label: attendantSearchSortByReviews(),
                icon: <ArrowDown10></ArrowDown10>,
              },
              {
                value: AttendantSearchSortBy.LIKES_DESC,
                label: 'Likes',
                icon: <Heart className='text-pink-500'></Heart>,
              },
            ]}
          ></ResponsiveSelect>
          <Button
            variant={'outline'}
            className='xl:hidden'
            size={'sm'}
            onClick={() => {
              setShowFilter(true);
            }}
          >
            <FilterIcon />
            <span>
              {attendantsFilterTitle()}{' '}
              {totalFilters > 0 && (
                <span className='text-brand'>({totalFilters})</span>
              )}
            </span>
          </Button>
        </div>
      </div>
    </>
  );
};

export { AttendantToolbar };
